import React, { FC } from "react";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import { IConversationsProps } from "../types";
import { ConversationItem } from "./ConversationItem";
import { useMessages } from "../MessagesContext";

const useStyles = makeStyles(() => ({
  root: {
    width: 391,
    minWidth: 391,
    height: 659,
    padding: "16px 0 16px 0",
    borderRadius: 16,
    backgroundColor: "#ffffff",
    boxShadow: "0 0 8px #C2C9D682",
  },
  list: {
    "overflow-y": "overlay",
    height: 627,
    marginRight: 2,
    padding: "8px 0 8px 24px",
  },
}));

export const Conversations: FC = () => {
  const classes = useStyles();
  const {
    conversations,
    selectedConversation,
    changeSelectedConversationInfo,
  } = useMessages() as IConversationsProps;

  return (
    <div className={classes.root}>
      <div className={clsx(classes.list, "transparent-scrollbar")}>
        {conversations?.map((conversation) => (
          <ConversationItem
            key={conversation.id}
            conversation={conversation}
            isSelected={selectedConversation?.id === conversation.id}
            changeSelectedConversationInfo={changeSelectedConversationInfo}
          />
        ))}
      </div>
    </div>
  );
};
